"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var componentStyle = {
    contentContainer: {
        maxWidth: 800,
        margin: '0 auto',
    },
    h1: {
        fontSize: 32,
        fontWeight: 300,
    },
};
var description = 'You can set a title, some items to the drawer and content.';
var code = "import React from 'react';\nimport { Layout, DrawerItem, DrawerSubitemsContainer } from 'jsc-react-ui';\n\nconst style = {\n  contentContainer: {\n    maxWidth: 800,\n    margin: '0 auto',\n  },\n  h1: {\n    fontSize: 32,\n    fontWeight: 300,\n  },\n};\n\nconst Example = () => (\n  <Layout\n    title=\"App Name\"\n    drawerItems={[\n      <DrawerItem key=\"1\" text=\"Upload\" />,\n      <DrawerSubitemsContainer key=\"2\" text=\"Media\">\n        <DrawerItem text=\"Photos\" subitem />\n        <DrawerItem text=\"Videos\" subitem />\n      </DrawerSubitemsContainer>\n    ]}\n  >\n    <div style={style.contentContainer}>\n      <h1 style={style.h1}>Some content</h1>\n    </div>\n  </Layout>\n)";
exports.ContentExampleLayout = function () { return (React.createElement(common_1.Example, { title: "Content", description: description, code: code },
    React.createElement(components_1.Layout, { title: "App Name", drawerItems: [
            React.createElement(components_1.DrawerItem, { key: "1", text: "Upload" }),
            React.createElement(components_1.DrawerSubitemsContainer, { key: "2", text: "Media" },
                React.createElement(components_1.DrawerItem, { text: "Photos", subitem: true }),
                React.createElement(components_1.DrawerItem, { text: "Videos", subitem: true })),
        ] },
        React.createElement("div", { style: componentStyle.contentContainer },
            React.createElement("h1", { style: componentStyle.h1 }, "Some content"))))); };
exports.ContentExampleLayout.displayName = 'ContentExampleLayout';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentLayoutPage/ContentExampleLayout.tsx
// module id = 691
// module chunks = 0